import angular           from 'angular'

import Carousel          from './carousel'
import CatalogNavbar     from './catalog-navbar'
import ProductCategories from './product-categories'
import ProductFilters    from './product-filters'
import ProductTile       from './product-tile'
import Products          from './products'
import ProductsBasket    from './products-basket'
import DurationPrice     from './duration-price'

let module = angular.module('catalog.components', [
  Carousel,
  CatalogNavbar,
  ProductCategories,
  ProductFilters,
  ProductTile,
  Products,
  ProductsBasket,
  DurationPrice
])
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/index.js